<template>
  <div>
    <label
      v-if="title != 'hide'"
      v-bind:class="{
        'text-danger': current.errors && current.errors.categoria,
      }"
      >{{ title }}</label
    >
    <v-select
      label="nombre"
      v-model="current.subcategoria"
      :disabled="disabled"
      :filterable="false"
      :options="subcategorias"
      @search="onSearch"
      @input="change($event)"
      placeholder="Subcategoria..."
    >
      <template slot="no-options">subcategoría...</template>
      <template slot="option" slot-scope="option">
        <div class="selected d-center">
          {{ option.codigo }} - {{ option.nombre }}
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          {{ option.codigo }} - {{ option.nombre }}
        </div>
      </template>
    </v-select>
    <small
      v-if="current.errors && current.errors.categoria"
      class="form-text text-danger"
      >{{ current.errors.categoria }}</small
    >
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";

export default {
  props: {
    current: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      default: "Subcategoría",
    },
  },
  mounted() {
    this.refreshData();
    
  },
  data() {
    return {
      subcategorias: [],
    };
  },
  methods: {
    change() {
      this.$emit("change", event);
    },
    refreshData() {
      let self = this;
      DynamicService.fetch("cat", "subcategoria", {
        page: 1,
      }).then((res) => {
        self.subcategorias = res.data.results;      
      });
    },
    onChange(event) {
      this.$emit("onChange", event);
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      DynamicService.fetch("cat", "subcategoria", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.subcategorias = res.data;
        loading(false);
      });
    }, 350),
  },
};
</script>